// Feature/Bug #272: environment detection for the UI's "Preprod" badge.
//
// Resolution order:
//
// 1. ``VITE_APP_ENV`` build-time override (set by the CD pipeline per stage
//    — preferred for explicitness once the pipeline is updated).
// 2. Hostname sniffing — production is served from
//    ``thelab.theprojectlab.com``; everything else (preview Static Web
//    App URLs like ``*.azurestaticapps.net``, localhost dev, custom
//    preview slots) defaults to "preprod" so the badge stays visible
//    in any non-production environment.
//
// Until the CD pipeline starts setting ``VITE_APP_ENV=production`` for
// the prod stage, hostname sniffing is what's actually rejecting the
// badge from production. Leaving both code paths in place means
// flipping over to the env-var-driven approach later is a one-line
// pipeline change.

const PROD_HOSTNAMES = new Set<string>([
  'thelab.theprojectlab.com',
])

export type AppEnvironment = 'production' | 'preprod'

export const resolveAppEnvironment = (): AppEnvironment => {
  const fromEnv = (import.meta.env.VITE_APP_ENV || '').toLowerCase()
  if (fromEnv === 'production' || fromEnv === 'prod') return 'production'
  if (fromEnv === 'preprod' || fromEnv === 'staging' || fromEnv === 'development') {
    return 'preprod'
  }
  // No explicit env override — derive from hostname.
  if (typeof window !== 'undefined') {
    const host = (window.location.hostname || '').toLowerCase()
    if (PROD_HOSTNAMES.has(host)) return 'production'
  }
  return 'preprod'
}

export const isProduction = (): boolean => resolveAppEnvironment() === 'production'
